import React, { Dispatch, SetStateAction, useMemo } from 'react';
import { Membership } from 'works/legacy/graphql/works-membership';
import { Checkbox, Row, Typography } from 'antd';
import { useQuery } from '@common/hooks';
import {
  WorksMembershipPermissions,
  WorksMembershipPermissionsQueryResponse,
} from '@identity/graphql/queries/membership-permissions';
import { groupBy } from 'lodash';
import { FontSize } from '@common/tokens';

const { Text } = Typography;

type MemberViewPermissionsProps = {
  membership: Membership | undefined;
  setChangedPermissions: Dispatch<SetStateAction<Record<string, boolean>>>;
  changedPermissions: Record<string, boolean>;
  allowEdit: boolean;
};

export function MemberViewPermissions({
  membership,
  setChangedPermissions,
  changedPermissions,
  allowEdit,
}: MemberViewPermissionsProps) {
  const { data } = useQuery<WorksMembershipPermissionsQueryResponse>(
    WorksMembershipPermissions,
    {
      variables: {
        id: membership?.id,
      },
    }
  );

  const groupedPermissions = useMemo(() => {
    return groupBy(data?.worksMembershipPermissions, 'group');
  }, [data]);

  const onChange = (key: string, value: boolean) => {
    setChangedPermissions((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <>
      <div className="admin-member-view-drawer__permissions">
        {Object.entries(groupedPermissions).map(([title, permissionList]) => (
          <div key={title} style={{ marginTop: 16 }}>
            <Text className="admin-member-view-drawer__section-title">
              {title}
            </Text>
            {permissionList.map(({ label, enabled, key }) => (
              <Row key={key} style={{ marginTop: 16 }}>
                <Checkbox
                  onChange={(e) => onChange(key, e.target.checked)}
                  checked={changedPermissions[key] ?? enabled}
                  disabled={!allowEdit}
                >
                  <Text disabled={!allowEdit}>{label}</Text>
                </Checkbox>
              </Row>
            ))}
          </div>
        ))}
      </div>
      <style jsx>{`
        :global(.admin-member-view-drawer__section-title) {
          font-size: ${FontSize.md};
        }
      `}</style>
    </>
  );
}
